import { Action } from '../../common/actions/core/action';
import { ActionHandler } from '../../common/actions/core/action-handler';

import { OpenPacketDeleteSuccessAction } from './packet-delete-success-dialog.action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ITimeoutService, IWindowService } from 'angular';

/* @ngInject */
export default class PacketDeleteSuccessDialog implements ActionHandler {
  private dialogElement;
  private messageSuccess;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private $translate,
    private $sce
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#packet-delete-success-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  handle(action: Action) {
    if (action instanceof OpenPacketDeleteSuccessAction) {
      if(action.messageSuccess){
        this.messageSuccess = this.$sce.trustAsHtml(action.messageSuccess);
        this.openDialog();
      } else {
        this.$translate('dialog.packet.delete.success.message').then(value => {
          this.messageSuccess = this.$sce.trustAsHtml(value);
          this.openDialog();
        });;
      }
    }
  }

  public onClose() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  private close() {
    this.dialogElement.close();
    this.$window.location.href = "/?buySuccess=1"
  }
}



// WEBPACK FOOTER //
// ./src/app/packet/packet-delete-success-dialog/packet-delete-success-dialog.controller.ts